<template>
  <v-snackbar
    v-model="visible"
    location="top right"
    class="login-snackbar"
    :class="severityClass"
    timeout="4000"
    variant="text"
    elevation="0"
  >
    <div class="login-snackbar__card">
      <div class="login-snackbar__accent" aria-hidden="true" />
      <div class="login-snackbar__content">
        <v-icon
          :icon="severityIcon"
          class="login-snackbar__icon"
          size="20"
        />
        <div class="login-snackbar__text">
          <p class="login-snackbar__title">{{ displayTitle }}</p>
          <p v-if="displaySubtitle" class="login-snackbar__subtitle">
            {{ displaySubtitle }}
          </p>
        </div>
        <button
          type="button"
          class="login-snackbar__close"
          aria-label="Dismiss notification"
          @click="visible = false"
        >
          <v-icon icon="mdi-close" size="18" />
        </button>
      </div>
    </div>
  </v-snackbar>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

defineOptions({ name: 'LoginSnackbar' })

const props = defineProps({
  snackbar: {
    type: Object,
    default: () => ({}),
  },
})

const visible = ref(false)
const local = ref({
  SnackbarColor: 'success',
  SnackbarText: '',
  SnackbarTitle: '',
  SnackbarSubtitle: '',
})

const severityClass = computed(
  () => `login-snackbar--${local.value.SnackbarColor || 'success'}`,
)

const severityIcon = computed(() => {
  const map = {
    success: 'mdi-check-circle-outline',
    error: 'mdi-alert-circle-outline',
    warning: 'mdi-alert-outline',
    info: 'mdi-information-outline',
  }
  return map[local.value.SnackbarColor] || map.success
})

const displayTitle = computed(() => {
  if (local.value.SnackbarTitle) return local.value.SnackbarTitle
  return local.value.SnackbarText
})

const displaySubtitle = computed(() => {
  if (local.value.SnackbarSubtitle) return local.value.SnackbarSubtitle
  return ''
})

watch(
  () => props.snackbar,
  (val) => {
    if (val?.SnackbarVmodel) {
      local.value = { ...val }
      visible.value = true
    }
  },
  { deep: true },
)
</script>
